export default __webpack_public_path__ + "static/media/eye-drops.f496e9f3.png";